$(document).ready(function(){
// FEATURE PRODUCT MEDIA GALLERY JS START
const thumbnailSlider = new Swiper('.thumbnail-slider', {
    spaceBetween: 15,
    slidesPerView: 'auto',
    freeMode: true,
    watchSlidesProgress: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    breakpoints: {
        320: {
            slidesPerView: 4,
            spaceBetween: 10,
        },
        640: {
            slidesPerView: 5,
            spaceBetween: 15,
        },
        768: {
            slidesPerView: 6,
            spaceBetween: 15,
        },
    },
});
const mainSlider = new Swiper('.main-slider', {
    spaceBetween: 5,
    effect: 'slide',
    // fadeEffect: {
        //   crossFade: true,
        // },
        thumbs: {
            swiper: thumbnailSlider,
        },
        keyboard: {
            enabled: true,
        },
        grabCursor: true,
        640: {
            slidesPerView: 5.8,
            spaceBetween: 8,
        },
    });
    
    // Show the "How It Works" button only on the first main slide
    (function controlHowItWorksBtnVisibility() {
        const howBtn = document.querySelector('.featured-product-section .how-it-works-btn');
        if (!howBtn || !mainSlider) return;
        
    const updateVisibility = () => {
        // Show only when the first slide is active (index 0)
        const isFirst = (mainSlider.activeIndex || 0) === 0;
        if (howBtn instanceof HTMLElement) {
            howBtn.style.display = isFirst ? '' : 'none';
        }
    };
    
    // Initial state
    updateVisibility();
    // Update on slide change
    mainSlider.on('slideChange', updateVisibility);
})();
    
})
// FEATURE PRODUCT MEDIA GALLERY JS
// SOCIAL PROOF SLIDER JS START
document.addEventListener('DOMContentLoaded', function () {

    function initReviewSliders() {
    if (window.innerWidth <= 767) return;

    // RTL Slider
    document.querySelectorAll('.review-card-slider.rtl').forEach((slider) => {
    if (slider.swiper) return; // prevent re-init

    new Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 24,
        loop: true,
        speed: 6000,
        allowTouchMove: false,
        autoplay: {
        delay: 0,
        reverseDirection: true,
        },
    });
    });

    // LTR Slider
    document.querySelectorAll('.review-card-slider.ltr').forEach((slider) => {
    if (slider.swiper) return; // prevent re-init

    new Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 24,
        loop: true,
        speed: 6000,
        allowTouchMove: false,
        autoplay: {
        delay: 0,
        reverseDirection: false,
        },
    });
    });
    }

    initReviewSliders();

    window.addEventListener('resize', initReviewSliders);

});
// SOCIAL PROOF SLIDER JS END